import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Semanticpmpmvt7fldq2 as Semantic } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Resources_getInstance2tvlmekcueurd as Resources_getInstance } from '../../Resources.js.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { get_dp28ag147e4p5cz as get_dp } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from './AppColors.mjs';
import { matchAlphaf1v7f410jfqp as matchAlpha } from './appTheme.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function copy(_this__u8e3s4, font, size, italic, bold, allCaps, lineSpacingMultiplier, additionalLetterSpacing) {
  font = font === VOID ? _this__u8e3s4.rb2_1 : font;
  size = size === VOID ? _this__u8e3s4.xb2_1 : size;
  italic = italic === VOID ? _this__u8e3s4.sb2_1 : italic;
  allCaps = allCaps === VOID ? _this__u8e3s4.ub2_1 : allCaps;
  lineSpacingMultiplier = lineSpacingMultiplier === VOID ? _this__u8e3s4.vb2_1 : lineSpacingMultiplier;
  additionalLetterSpacing = additionalLetterSpacing === VOID ? _this__u8e3s4.wb2_1 : additionalLetterSpacing;
  var tmp0_weight = bold ? 700 : 400;
  return _this__u8e3s4.fd1(font, italic, tmp0_weight, allCaps, lineSpacingMultiplier, additionalLetterSpacing, size);
}
var XLTitleSemanticClass;
function XLTitleSemantic() {
  if (XLTitleSemanticClass === VOID) {
    class $ extends Semantic() {
      static vjn() {
        XLTitleSemantic_instance = null;
        var $this = this.dd1('XLTitle');
        XLTitleSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        return this.gd1(theme, VOID, theme.gb0_1.fd1(Resources_getInstance().uf8_1, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().tg1_1));
      }
      toString() {
        return 'XLTitleSemantic';
      }
      hashCode() {
        return -1870068904;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof XLTitleSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'XLTitleSemantic');
    XLTitleSemanticClass = $;
  }
  return XLTitleSemanticClass;
}
var XLTitleSemantic_instance;
function XLTitleSemantic_getInstance() {
  if (XLTitleSemantic_instance === VOID)
    XLTitleSemantic().vjn();
  return XLTitleSemantic_instance;
}
function xlTitle(_this__u8e3s4, setup) {
  var tmp;
  if (setup === VOID) {
    tmp = xlTitle$lambda;
  } else {
    tmp = setup;
  }
  setup = tmp;
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.lba(view.qb6_1.abf(XLTitleSemantic_getInstance()));
  setup(view);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function xlTitle_0(_this__u8e3s4, content) {
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.lba(view.qb6_1.abf(XLTitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp = view.vb5_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(content) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = content;
  }
  tmp.hbu(tmp_0);
  _this__u8e3s4.hbb(p, view);
  return view;
}
var TitleSemanticClass;
function TitleSemantic() {
  if (TitleSemanticClass === VOID) {
    class $ extends Semantic() {
      static xjn() {
        TitleSemantic_instance = null;
        var $this = this.dd1('title');
        TitleSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        return this.gd1(theme, VOID, copy(theme.gb0_1, Resources_getInstance().uf8_1, get_AppDimensions().ug1_1, VOID, true));
      }
      toString() {
        return 'TitleSemantic';
      }
      hashCode() {
        return 1541027148;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof TitleSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'TitleSemantic');
    TitleSemanticClass = $;
  }
  return TitleSemanticClass;
}
var TitleSemantic_instance;
function TitleSemantic_getInstance() {
  if (TitleSemantic_instance === VOID)
    TitleSemantic().xjn();
  return TitleSemantic_instance;
}
function title(_this__u8e3s4, setup) {
  var tmp;
  if (setup === VOID) {
    tmp = title$lambda;
  } else {
    tmp = setup;
  }
  setup = tmp;
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.lba(view.qb6_1.abf(TitleSemantic_getInstance()));
  setup(view);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function title_0(_this__u8e3s4, content) {
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.lba(view.qb6_1.abf(TitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp = view.vb5_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(content) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = content;
  }
  tmp.hbu(tmp_0);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function titleWithClose(_this__u8e3s4, content, onClose) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(false);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.lba(view_0.qb6_1.abf(TitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp = view_0.vb5_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(content) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = content;
  }
  tmp.hbu(tmp_0);
  view.hbb(p_0, view_0);
  var tmp_1 = get_expanding(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Space())(view.pc());
  var tmp0_elvis_lhs_1 = view.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.gbb(p_1, view_1);
  view.hbb(p_1, view_1);
  view.lbb(tmp_1, view_1);
  var tmp_2 = view.kbb(get_centered(view), sizeConstraints(view, VOID, VOID, VOID, VOID, 1.0));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (Button())(view.pc());
  var tmp0_elvis_lhs_2 = view.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
  view.gbb(p_2, view_2);
  view_2.gba(get_dp(1));
  view_2.bb9(get_dp(1));
  icon(view_2, Companion_getInstance().vcf_1, 'Close Dialog');
  onClick(view_2, VOID, VOID, titleWithClose$slambda_0(onClose));
  view.hbb(p_2, view_2);
  view.lbb(tmp_2, view_2);
  _this__u8e3s4.hbb(p, view);
  return view;
}
var SubtitleSemanticClass;
function SubtitleSemantic() {
  if (SubtitleSemanticClass === VOID) {
    class $ extends Semantic() {
      static zjn() {
        SubtitleSemantic_instance = null;
        var $this = this.dd1('subTitle');
        SubtitleSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        return this.gd1(theme, VOID, theme.gb0_1.fd1(VOID, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().vg1_1));
      }
    }
    initMetadataForObject($, 'SubtitleSemantic');
    SubtitleSemanticClass = $;
  }
  return SubtitleSemanticClass;
}
var SubtitleSemantic_instance;
function SubtitleSemantic_getInstance() {
  if (SubtitleSemantic_instance === VOID)
    SubtitleSemantic().zjn();
  return SubtitleSemantic_instance;
}
function boldSubTitle(_this__u8e3s4, content) {
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.lba(view.qb6_1.abf(SubtitleSemantic_getInstance().abf(BoldSemantic_getInstance())));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp = view.vb5_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(content) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = content;
  }
  tmp.hbu(tmp_0);
  _this__u8e3s4.hbb(p, view);
  return view;
}
var BodySemanticClass;
function BodySemantic() {
  if (BodySemanticClass === VOID) {
    class $ extends Semantic() {
      static bjo() {
        BodySemantic_instance = null;
        var $this = this.dd1('body');
        BodySemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        return this.gd1(theme, VOID, theme.gb0_1.fd1(VOID, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().wg1_1));
      }
      toString() {
        return 'BodySemantic';
      }
      hashCode() {
        return -232335686;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof BodySemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'BodySemantic');
    BodySemanticClass = $;
  }
  return BodySemanticClass;
}
var BodySemantic_instance;
function BodySemantic_getInstance() {
  if (BodySemantic_instance === VOID)
    BodySemantic().bjo();
  return BodySemantic_instance;
}
function body(_this__u8e3s4, content, align) {
  align = align === VOID ? null : align;
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.lba(view.qb6_1.abf(BodySemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp = view.vb5_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(content) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = content;
  }
  tmp.hbu(tmp_0);
  if (!(align == null)) {
    view.dbs(align);
  }
  _this__u8e3s4.hbb(p, view);
  return view;
}
function centeredBody(_this__u8e3s4, content) {
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.lba(view.qb6_1.abf(BodySemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp = view.vb5_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(content) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = content;
  }
  tmp.hbu(tmp_0);
  view.dbs(Align_Center_getInstance());
  _this__u8e3s4.hbb(p, view);
  return view;
}
function bodyBold(_this__u8e3s4, content) {
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.lba(view.qb6_1.abf(BodySemantic_getInstance().abf(BoldSemantic_getInstance())));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp = view.vb5_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(content) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = content;
  }
  tmp.hbu(tmp_0);
  _this__u8e3s4.hbb(p, view);
  return view;
}
var SmallBodySemanticClass;
function SmallBodySemantic() {
  if (SmallBodySemanticClass === VOID) {
    class $ extends Semantic() {
      static djo() {
        SmallBodySemantic_instance = null;
        var $this = this.dd1('smallBody');
        SmallBodySemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        return this.gd1(theme, VOID, theme.gb0_1.fd1(VOID, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().xg1_1), VOID, VOID, VOID, VOID, matchAlpha(AppColors_getInstance().hfz_1.zg9_1, theme.lb0_1));
      }
    }
    initMetadataForObject($, 'SmallBodySemantic');
    SmallBodySemanticClass = $;
  }
  return SmallBodySemanticClass;
}
var SmallBodySemantic_instance;
function SmallBodySemantic_getInstance() {
  if (SmallBodySemantic_instance === VOID)
    SmallBodySemantic().djo();
  return SmallBodySemantic_instance;
}
function smallBody(_this__u8e3s4, content) {
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.lba(view.qb6_1.abf(SmallBodySemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp = view.vb5_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(content) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = content;
  }
  tmp.hbu(tmp_0);
  _this__u8e3s4.hbb(p, view);
  return view;
}
var BoldSemanticClass;
function BoldSemantic() {
  if (BoldSemanticClass === VOID) {
    class $ extends Semantic() {
      static fjo() {
        BoldSemantic_instance = null;
        var $this = this.dd1('bold');
        BoldSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        return this.gd1(theme, VOID, theme.gb0_1.vd4(VOID, VOID, true));
      }
    }
    initMetadataForObject($, 'BoldSemantic');
    BoldSemanticClass = $;
  }
  return BoldSemanticClass;
}
var BoldSemantic_instance;
function BoldSemantic_getInstance() {
  if (BoldSemantic_instance === VOID)
    BoldSemantic().fjo();
  return BoldSemantic_instance;
}
function xlTitle$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function title$lambda(_this__u8e3s4) {
  return Unit_instance;
}
var titleWithClose$slambdaClass;
function titleWithClose$slambda() {
  if (titleWithClose$slambdaClass === VOID) {
    class $ {
      constructor($onClose) {
        this.gjo_1 = $onClose;
      }
      uao($completion) {
        this.gjo_1();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    titleWithClose$slambdaClass = $;
  }
  return titleWithClose$slambdaClass;
}
function titleWithClose$slambda_0($onClose) {
  var i = new (titleWithClose$slambda())($onClose);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
//region block: exports
export {
  bodyBold as bodyBold2czwdzwknab0k,
  body as body3i5t0n7zprpqb,
  boldSubTitle as boldSubTitle1bjbn9bt8inbw,
  centeredBody as centeredBody28evt7zh2q8en,
  copy as copy52djz8jpwbje,
  smallBody as smallBody2trfy14zwtona,
  titleWithClose as titleWithClose1c8wgipb8qrii,
  title as title1ahgushtajx2d,
  title_0 as title1nssp3ryhwuqj,
  xlTitle as xlTitle1ubqveqr3xlnc,
  xlTitle_0 as xlTitle2v7mu4p1j9wv3,
  BodySemantic_getInstance as BodySemantic_getInstancembkce4y4wobt,
  BoldSemantic_getInstance as BoldSemantic_getInstance3sy4hmow8wwn9,
  SmallBodySemantic_getInstance as SmallBodySemantic_getInstance13vsg4635cu56,
  SubtitleSemantic_getInstance as SubtitleSemantic_getInstance37873sehsd699,
  TitleSemantic_getInstance as TitleSemantic_getInstance11rbkzaor5oxz,
};
//endregion

//# sourceMappingURL=Titles.mjs.map
